export const BLOG_HERO_IMAGE = "/images/blog/blog-hero.png";
